@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-swamp-green);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.root--is-visible {
  opacity: 1;
  pointer-events: all;
}

.close {
  position: absolute;
  top: var(--spacer-4);
  right: var(--spacer-4);

  @include media-breakpoint-down("md") {
    top: var(--spacer-2);
    right: var(--spacer-2);
  }
}

.shop {
  margin-bottom: var(--spacer-9);

  @include media-breakpoint-down("md") {
    margin-bottom: var(--spacer-7);
  }
}

// no idea why but <a> items are not green unless I add extra specifity. Even though dev tools says they're green.
a.item,
.item {
  @include typo--menu-item;
  color: var(--color-bright-green);
  appearance: none;
  border: none;
  background: none;
  transition: text-shadow 0.4s ease;

  &:not(:last-child) {
    margin-bottom: var(--spacer-3);

    @include media-breakpoint-down("md") {
      margin-bottom: var(--spacer-2);
    }
  }

  @include hover {
    text-shadow: 0px 0px 6px var(--color-bright-green);
  }
}
